const listeners = new Set();
const loadingListeners = new Set();
let pendingReads = 0;
export function subscribePageLoading(listener) {
  loadingListeners.add(listener);
  return () => loadingListeners.delete(listener);
}
export function isPageLoading() { return pendingReads > 0; }
function changePendingReads(change) {
  pendingReads += change;
  loadingListeners.forEach(listener => listener());
}
export function subscribeSession(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function updateSession(user) {
  listeners.forEach(listener => listener(user));
}
export async function sessionFetch(url, options) {
  const { background = false, ...fetchOptions } = options || {};
  const read = !background && (!fetchOptions.method || fetchOptions.method.toUpperCase() === 'GET');
  if (read) changePendingReads(1);
  try {
    const response = await fetch(url, { ...fetchOptions, credentials: 'include' });
    if (response.status === 401 && !/\/auth\/(login|google)$/.test(String(url).split('?')[0])) updateSession(null);
    return response;
  } finally {
    if (read) changePendingReads(-1);
  }
}
